/* eslint-disable react-hooks/exhaustive-deps */
import React, { useEffect, useState } from "react";

const API = process.env.REACT_APP_API_URL || "/api";

const Maintenance = () => {
  const [list, setList] = useState([]);
  const [form, setForm] = useState({
    device_id: "",
    title: "",
    description: "",
    scheduled_date: "",
  });

  const token = localStorage.getItem("token");

  /* ================= FETCH ================= */
  const fetchData = async () => {
    try {
      const res = await fetch(`${API}/maintenance`, {
        headers: { Authorization: `Bearer ${token}` },
      });

      const data = await res.json();

      // ✅ FIX (IMPORTANT)
      const safeData = Array.isArray(data)
        ? data
        : data.rows || data.data || [];

      setList(safeData);

    } catch (err) {
      console.error(err);
      setList([]);
    }
  };

  useEffect(() => {
    fetchData();
  // Load maintenance records once when the page opens.
  // eslint-disable-next-line react-hooks/exhaustive-deps
  }, []);

  /* ================= ADD ================= */
  const addMaintenance = async () => {
    if (!form.device_id || !form.title) return;

    await fetch(`${API}/maintenance`, {
      method: "POST",
      headers: {
        "Content-Type": "application/json",
        Authorization: `Bearer ${token}`,
      },
      body: JSON.stringify(form),
    });

    setForm({
      device_id: "",
      title: "",
      description: "",
      scheduled_date: "",
    });

    fetchData();
  };

  /* ================= COMPLETE ================= */
  const markDone = async (id) => {
    await fetch(`${API}/maintenance/${id}/complete`, {
      method: "PUT",
      headers: { Authorization: `Bearer ${token}` },
    });

    fetchData();
  };

  return (
    <div>
      <h1 className="text-xl font-semibold text-slate-800 mb-6">
        Maintenance
      </h1>

      {/* FORM */}
      <div className="bg-white border rounded-xl p-4 mb-6 flex gap-2 flex-wrap">
        <input
          placeholder="Device ID"
          value={form.device_id}
          onChange={(e)=>setForm({...form,device_id:e.target.value})}
          className="border p-2"
        />

        <input
          placeholder="Title"
          value={form.title}
          onChange={(e)=>setForm({...form,title:e.target.value})}
          className="border p-2"
        />

        <input
          placeholder="Description"
          value={form.description}
          onChange={(e)=>setForm({...form,description:e.target.value})}
          className="border p-2"
        />

        <input
          type="date"
          value={form.scheduled_date}
          onChange={(e)=>setForm({...form,scheduled_date:e.target.value})}
          className="border p-2"
        />

        <button
          onClick={addMaintenance}
          className="bg-blue-600 text-white px-4 rounded"
        >
          Add
        </button>
      </div>

      {/* TABLE */}
      <div className="bg-white border rounded-xl overflow-hidden">
        <table className="w-full text-sm">
          <thead className="bg-slate-50 text-xs">
            <tr>
              <th className="px-4 py-2 text-left">Device</th>
              <th className="px-4 py-2 text-left">Title</th>
              <th className="px-4 py-2 text-left">Date</th>
              <th className="px-4 py-2 text-left">Status</th>
              <th className="px-4 py-2 text-left">Action</th>
            </tr>
          </thead>

          <tbody>
            {list.length === 0 ? (
              <tr>
                <td colSpan="5" className="p-6 text-center text-gray-400">
                  No maintenance records
                </td>
              </tr>
            ) : (
              list.map((m) => (
                <tr key={m.id} className="border-t">
                  <td className="px-4 py-2">
                    {m.device_uid || "-"}
                  </td>

                  <td className="px-4 py-2">{m.title}</td>

                  <td className="px-4 py-2">
                    {new Date(m.scheduled_date).toLocaleDateString()}
                  </td>

                  <td className="px-4 py-2">
                    <span className={`px-2 py-1 text-xs rounded ${
                      m.status === "completed"
                        ? "bg-green-100 text-green-600"
                        : "bg-yellow-100 text-yellow-600"
                    }`}>
                      {m.status}
                    </span>
                  </td>

                  <td className="px-4 py-2">
                    {m.status !== "completed" && (
                      <button
                        onClick={()=>markDone(m.id)}
                        className="text-blue-600"
                      >
                        Mark Done
                      </button>
                    )}
                  </td>
                </tr>
              ))
            )}
          </tbody>
        </table>
      </div>

    </div>
  );
};

export default Maintenance;
